(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/components/receiver/receiver-details.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/components/receiver/receiver-details.js');

'use strict';

const {
  isCorporateSite
} = svs.grassroots.shared.data;
const {
  ReactBadge: Badge,
  ReactIcon,
  Button
} = svs.ui;
const Corporate = svs.grassroots.components.receiver.corporate;
const NonCorporate = svs.grassroots.components.receiver.non_corporate;
const ReceiverDetails = _ref => {
  let {
    receiver
  } = _ref;
  const {
    id,
    longname,
    subcategory,
    supporters,
    points,
    location,
    homepage,
    yearlypayouts,
    latestperiodamount
  } = receiver;
  const [displayMorePayouts, setDisplayMorePayouts] = React.useState(false);
  const orderedYearlyPayoutYears = Object.keys(yearlypayouts !== null && yearlypayouts !== void 0 ? yearlypayouts : []).sort((a, b) => b - a);
  const toggleDisplayPayouts = () => {
    setDisplayMorePayouts(prev => !prev);
  };

  const displayToggleButton = () => {
    if (orderedYearlyPayoutYears.length > 2) {
      return React.createElement(Button, {
        branding: svs.grassroots.tenant,
        className: "right margin-bottom-1",
        onClick: toggleDisplayPayouts,
        size: 100,
        transparent: true
      }, !displayMorePayouts ? 'Visa fler' : 'Visa färre');
    }
  };

  const YearlyPayout = _ref2 => {
    var _yearlypayouts$year;
    let {
      year
    } = _ref2;
    return React.createElement("div", {
      className: "grid-row",
      key: year
    }, React.createElement("div", {
      className: "col-xs-6 align-left"
    }, React.createElement("p", null, year, ":")), React.createElement("div", {
      className: "col-xs-6 align-right"
    }, React.createElement("p", null, yearlypayouts === null || yearlypayouts === void 0 || (_yearlypayouts$year = yearlypayouts[year]) === null || _yearlypayouts$year === void 0 ? void 0 : _yearlypayouts$year.toLocaleString('sv-SE'), ' ', "kr")));
  };
  return React.createElement("div", {
    className: "padding-1 f-content grassroots-receiver-details-container"
  }, React.createElement("h4", {
    className: "grassroots-receiver-details-name"
  }, longname, ' ', subcategory ? React.createElement("p", {
    className: "inline-block f-normal"
  }, '- ', subcategory, ' ') : React.createElement(Badge, {
    className: "grassroots-badge"
  }, "Huvudf\xF6rening")), React.createElement("p", null, location === null || location === void 0 ? void 0 : location.city), React.createElement("p", null, React.createElement(ReactIcon, {
    className: "padding-right-1",
    icon: "players",
    size: "300"
  }), "".concat(supporters === null || supporters === void 0 ? void 0 : supporters.toLocaleString('sv-SE'), " st"), React.createElement(ReactIcon, {
    className: "padding-right-1 margin-left-1",
    icon: "points",
    size: "300"
  }), "".concat(points === null || points === void 0 ? void 0 : points.toLocaleString('sv-SE'), " p")), homepage && React.createElement("a", {
    className: "fc-navy",
    href: homepage,
    rel: "nofollow noopener noreferrer",
    target: "_blank"
  }, homepage, React.createElement(ReactIcon, {
    className: "u-text-decoration-none",
    icon: "link-external",
    size: 100
  })), React.createElement("div", {
    className: "margin-top-2 grid-row"
  }, React.createElement("div", {
    className: "col-xs-8 align-left"
  }, React.createElement("p", {
    className: "f-medium"
  }, "Sektionens senaste belopp:")), React.createElement("div", {
    className: "col-xs-4 align-right"
  }, React.createElement("p", null, latestperiodamount === null || latestperiodamount === void 0 ? void 0 : latestperiodamount.toLocaleString('sv-SE'), ' ', "kr"))), orderedYearlyPayoutYears.length > 0 && React.createElement("div", null, React.createElement("p", null, "F\xF6reningens \xE5rsbelopp:"), orderedYearlyPayoutYears.filter((_, index) => index < 2).map(year => React.createElement(YearlyPayout, {
    key: year,
    year: year
  })), displayMorePayouts && orderedYearlyPayoutYears.filter((_, index) => index > 1).map(year => React.createElement(YearlyPayout, {
    key: year,
    year: year
  })), displayToggleButton()), 
  id && (isCorporateSite ? React.createElement(Corporate, {
    id: id
  }) : React.createElement(NonCorporate, {
    receiver: receiver
  })));
};
svs.grassroots.components.receiver.receiver_details = ReceiverDetails;

 })(window);